export const SET_ONLINE_USERS = 'onlineUsers/SET_ONLINE_USERS';
export const CLEAR_ONLINE_USERS = 'onlineUsers/CLEAR_ONLINE_USERS';
export const ADD_ONLINE_USER = 'onlineUsers/ADD_ONLINE_USER';
export const UPDATE_ONLINE_USER = 'onlineUsers/UPDATE_ONLINE_USER';
export const REMOVE_ONLINE_USER = 'onlineUsers/REMOVE_ONLINE_USER';


export const setOnlineUsers = (users) => {
  try { localStorage.setItem('onlineUsers', JSON.stringify(users)); } catch (e) {}
  return { type: SET_ONLINE_USERS, payload: users };
};

export const clearOnlineUsers = () => {
  try { localStorage.removeItem('onlineUsers'); } catch (e) {}
  return { type: CLEAR_ONLINE_USERS };
};
export const addOnlineUser = (user) => {
  return { type: ADD_ONLINE_USER, payload: user };
}
export const updateOnlineUser = (user) => {
  return { type: UPDATE_ONLINE_USER, payload: user };
}
export const removeOnlineUser = (userId) => {
  return { type: REMOVE_ONLINE_USER, payload: userId };
}
  